import { atom, useRecoilValue, useSetRecoilState } from 'recoil';

export const currentPavilion = atom<string | null>({
    key: 'currentPavilion',
    default: (typeof window !== 'undefined' ? new URLSearchParams(window.location.search).get('slug') : null) || null,
});

export const useCurrentPavilionValue = () => useRecoilValue(currentPavilion);
export const useCurrentPavilionSetState = () => useSetRecoilState(currentPavilion);
